import {modelHydrator} from "./_modelHydrator";
import {bodyAreaResultType} from "../../types/Api/BodyAreaResultType";
import {bodyArea} from "../bodyArea";

export const bodyAreaHydrator = {
  hydrate: (bodyArea: bodyAreaResultType): bodyArea => {
    return Object.assign({
      bodyAreaId: bodyArea.bodyAreaId,
      label: bodyArea.label,
      slug: bodyArea.slug,
    }, modelHydrator.hydrate(bodyArea))
  }
}